export const CASE_MANAGER_CENSUS_DEFAULT_SORT = {
  sortedColumn: 'caseManager',
  sortedColumnOrder: 'ascend'
}
